import * as types from './types';

const hashById = (events) => {
  const hash = {};
  /* eslint-disable-next-line no-restricted-syntax */
  for (const event of events) {
    hash[event.id] = event;
  }
  return hash;
};

const initialState = {
  events: {},
};

export default (state = initialState, action) => {
  const { events } = action;
  switch (action.type) {
    case types.ADD_EVENTS:
      // Hash the events by id in an object. This helps prevent
      // duplicate events when fetching events already stored in state.
      return {
        events: { ...state.events, ...hashById(events) },
      };
    case types.UPDATE_EVENT:
      return {
        events: updateEventById(state.events, action.payload),
      };
    case types.REMOVE_EVENT:
      return {
        events: removeEventById(state.events, action.payload),
      };
    default:
      return state;
  }
};

const updateEventById = (events, { id, data }) => {
  const newEvents = { ...events };
  if (newEvents[id]) {
    newEvents[id] = { ...newEvents[id], ...data };
  } else if (id) {
    newEvents[id] = data;
  }
  return newEvents;
};

const removeEventById = (events, { id }) => {
  const newEvents = { ...events };
  if (newEvents[id]) {
    delete newEvents[id];
  }
  return newEvents;
};
